import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../component/admin-v2/Layout";
import ProtectedRoute from "./ProtectedRoute";
import AdminLogin from "../component/admin-v2/AdminLogin";

const ProductAdminPage = lazy(() =>
  import("../component/admin-v2/product/ProductAdminPage")
);

const AdminV2Routes = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/login" element={<AdminLogin />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/product" element={<ProductAdminPage />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default AdminV2Routes;
